import {useEffect} from 'react';
import {COLORS, LED_SELECTORS} from '../utils/consts';
import {DATAPOINT_BLINK_MAPPING, DATAPOINT_IS_ONLINE} from '../../../../modules/common/consts';
import {setColorAndFlashing} from '../../../common/blinkHelpers';
import {WidgetSvg} from './types';
import {AssetsWithLiveData} from '../../common/useAssetSubscription';

const useFloorplanDeviceColors = (
	svgRootObj: WidgetSvg | undefined,
	assetsLiveData: AssetsWithLiveData,
	editMode: boolean,
	widgetKey: string
) => {
	useEffect(() => {
		if (svgRootObj && !editMode) {
			Object.keys(assetsLiveData).forEach((assetId) => {
				const assetLiveData = assetsLiveData[assetId];
				Object.keys(assetLiveData).forEach((datapointName) => {
					const dataPointValue = assetLiveData[datapointName];
					const elementSelector = `#added_device_${assetId} ${LED_SELECTORS[datapointName]}`;
					const elementToChange = svgRootObj.select(elementSelector);

					if (elementToChange) {
						if (datapointName === DATAPOINT_IS_ONLINE) {
							elementToChange.style('fill', dataPointValue ? COLORS.GREEN : COLORS.RED);
						} else if (DATAPOINT_BLINK_MAPPING[datapointName]) {
							setColorAndFlashing(
								parseInt(assetId),
								elementToChange,
								DATAPOINT_BLINK_MAPPING[datapointName],
								dataPointValue,
								assetLiveData[DATAPOINT_BLINK_MAPPING[datapointName]],
								widgetKey
							);
						}
					}
				});
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [assetsLiveData, svgRootObj, editMode]);
};

export default useFloorplanDeviceColors;
